'use strict';
function range() {
	return function(input, range) {
		if(angular.isArray(range)) {return input.slice(range[0], range[1]); }
		return (range === 'tail') ? input.slice(1, input.length) : input.slice(0, input.length-1);
	};
}
export default range



// WEBPACK FOOTER //
// ./src/app/scripts/helpers/listRangeFilter.js